import { FC } from 'react';
import { Chip } from '@mui/material';
import { capitalize } from 'lodash';
import { WorkbenchStatusEnum } from '~/api/types';
import { InitializingIcon, PendingIcon, RunningIcon, StoppedIcon, TerminatedIcon } from '~/icons';

interface WorkbenchStatusCellProps {
  status: WorkbenchStatusEnum;
}

const workbenchStatusChipConfig: Record<
  WorkbenchStatusEnum | string,
  { customColor: string; customIcon: JSX.Element }
> = {
  [WorkbenchStatusEnum.STOPPED]: {
    customColor: 'cautionHighlight.main',
    customIcon: <StoppedIcon />,
  },
  [WorkbenchStatusEnum.INITIALIZING]: {
    customColor: 'black10.main',
    customIcon: <InitializingIcon />,
  },
  [WorkbenchStatusEnum.STOPPING]: {
    customColor: 'cautionHighlight.main',
    customIcon: <PendingIcon />,
  },
  [WorkbenchStatusEnum.RUNNING]: {
    customColor: 'success.light',
    customIcon: <RunningIcon />,
  },
  [WorkbenchStatusEnum.PENDING]: {
    customColor: 'cautionHighlight.main',
    customIcon: <PendingIcon />,
  },
  default: {
    customColor: 'criticalHighlight.main',
    customIcon: <TerminatedIcon />,
  },
};

const WorkbenchStatusCell: FC<WorkbenchStatusCellProps> = ({ status }) => {
  const config = workbenchStatusChipConfig[status] || workbenchStatusChipConfig.default;

  return (
    <Chip
      label={capitalize(status)}
      icon={config.customIcon}
      sx={{
        p: 1,
        fontSize: '1.5rem',
        backgroundColor: config.customColor,
      }}
    />
  );
};

export default WorkbenchStatusCell;
